define('requester/json',["aja", "./template"], function (aja, template) {
    "use strict";

    function addQueryParams(options, req) {
        return options.queryParameters ? req.data(options.queryParameters) : req;
    }

    function addFailHandler(options, req) {
        return options.fail ? req.on("error", options.fail).on("4xx", options.fail).on("5xx", options.fail) : req;
    }

    return {
        /**
         * Executes a request and processes the response as JSON.
         * @method get
         * @param {Object} options Specifies the details of the request.
         * @param {String} options.url The URL to request.
         * @param {Object} [options.queryParameters] The data to pass as GET parameters with the request.
         * @param {Object} [options.pathParameters] The data to use as {placeholders} in url.
         * @param {Function} [options.fail] The callback to execute when the request fails.
         * @param {Function} options.callback The callback to execute when the request completes.
         */
        get: function (options) {
            options.pathParameters = options.pathParameters || {};
            options.pathParameters.contentType = "json";
            options.pathParameters.protocol = options.pathParameters.protocol || "https";

            var url = template(options.url, options.pathParameters);

            var req = aja().url(url);
            req = addQueryParams(options, req);
            req = addFailHandler(options, req);
            req.on("400", options.callback)
            req.on("success", options.callback).go();
        }
    };
});

